<template>
  <el-select ref="team" v-model="selected" placeholder="Selecione  uma opção" @change="update()">
    <el-option v-for="row of teams" :key="row.id" :label="row.name" :value="row.id"></el-option>
  </el-select>
</template>

<script>
import { TeamService } from "@/services/umov/team.services";
export default {
  name: "TeamList",
  props: {
    current: String,
  },
  watch: {
    current() {
      const vm = this;
      if (vm.$props.current) {
        vm.selected = vm.$props.current;
      }
    },
  },
  data: function () {
    return {
      teams: [],
      selected: "",
    };
  },
  methods: {
    fetchTeams() {
      const vm = this;
      TeamService.list()
        .then((response) => {
          vm.teams = response.records;
          setTimeout(() => {
            if (vm.$props.current) {
              vm.selected = vm.$props.current;
            }
          }, 500);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      vm.$emit('change', vm.selected)
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchTeams();
  },
};
</script>